/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { NameDto } from '../../models/name-dto';

export interface ClientControllerFindAllDropdown$Params {
  officeId?: number;
  housingId?: number;
  initial: boolean;
  sIds?: Array<number>;
}

export function clientControllerFindAllDropdown(http: HttpClient, rootUrl: string, params: ClientControllerFindAllDropdown$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<NameDto>>> {
  const rb = new RequestBuilder(rootUrl, clientControllerFindAllDropdown.PATH, 'get');
  if (params) {
    rb.query('officeId', params.officeId, {});
    rb.query('housingId', params.housingId, {});
    rb.query('initial', params.initial, {});
    rb.query('sIds', params.sIds, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<NameDto>>;
    })
  );
}

clientControllerFindAllDropdown.PATH = '/api/client/dropdown';
